// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"142":"d0798701","293":"1f61a2ad","574":"26fa50ff","953":"064c492d"}[chunkId] + ".js";
};